import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_protection_from_falling_objects_underneath_graded_surfaces'

export const dataPointDefinition = {
  retracedId: 'no_protection_from_falling_objects_underneath_graded_surfaces',
  name: 'No protection from falling objects underneath graded surfaces',
  description:
    'Refers to the facility protecting workers from objects falling from above onto them (e.g. if there is a raised platform, there are guardrails on raised platforms to prevent materials from falling off).',
  meta: {
    slcpMeta: {
      key: 'hs-bui-26x',
      number: 'HS-BUI-5-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-21',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-26x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
